<section class="support-page app-grid-fluid">
  <div class="grid grid-nogutter justify-content-center">
    <div class="col-12 sm:col-10 lg:col-8 xl:col-7 support-page__content">
      <section class="support-page__panel">
        <div class="support-page__contact">
          <i class="pi pi-envelope" aria-hidden="true"></i>
          <div>
            <h2>{{ 'features.support.contact_title' | translate }}</h2>
            <p class="support-page__intro">{{ 'features.support.intro' | translate }}</p>
            <p>{{ 'features.support.contact_description' | translate }}</p>
            <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>
          </div>
        </div>
      </section>

      <section class="support-page__panel support-page__report">
        <h2>{{ 'features.support.form_title' | translate }}</h2>
        <p>{{ 'features.support.form_description' | translate }}</p>
        <app-support-request-form [allowAttachments]="isAuthenticated"></app-support-request-form>
      </section>
    </div>
  </div>
</section>
